/**
 * Taking payment for an invoiced lens job, in the job dialogs' invoice card: how much (what's due now,
 * or the whole balance), how it was paid, and - where the job's invoice is in Xero - the bank account
 * it went into. Recorded against the job's Xero invoice and kept on the job. An invoice kept in CatTrax
 * only takes its payments there; they go into Xero when the invoice is raised there.
 *
 * The bank account last used at this practice is remembered in this browser.
 */
app.component("lensJobPayment", {
	templateUrl: "app/src/js/components/lensDispensing/lensJobPayment.html",
	controller: "lensJobPaymentController",
	bindings: {
		job: "<",
		patientId: "<",
		onPaid: "&",
	},
});

app.controller("lensJobPaymentController", [
	"$scope",
	"Session",
	"BillingAPI",
	"LensDispensingStore",
	"REFERENCE_TYPE",
	"toast",
	function ($scope, Session, BillingAPI, Store, REFERENCE_TYPE, toast) {
		const $ctrl = this;
		const accountKey = () => "cattrax.lensPaymentAccount." + ((Session.practice && Session.practice.id) || "");

		$scope.methods = REFERENCE_TYPE;
		$scope.form = { amount: null, method: "EFTPOS", accountId: null };
		$scope.accounts = { list: [], loading: false, error: null };
		$scope.saving = false;

		$scope.owing = () => Store.owing($ctrl.job);
		$scope.dueNow = () => Store.dueNow($ctrl.job);
		$scope.inXero = () => !!($ctrl.job && $ctrl.job.invoice && $ctrl.job.invoice.xeroId);

		$ctrl.$onInit = function () {
			$scope.form.amount = $scope.dueNow() || $scope.owing();
			// Read once the invoice is in Xero - when the dialog opens, or once it is raised there.
			$scope.$watch($scope.inXero, (inXero) => inXero && !$scope.accounts.list.length && !$scope.accounts.loading && loadAccounts());
		};

		// The organisation's bank accounts - where a payment is put in Xero.
		function loadAccounts() {
			$scope.accounts.loading = true;
			BillingAPI.getLoggedIn()
				.then(function (resp) {
					$scope.accounts.list = ((resp.data && resp.data.accounts) || []).filter((a) => a.account_class === "BANK");
					let remembered = null;
					try {
						remembered = window.localStorage.getItem(accountKey());
					} catch (e) {
						remembered = null;
					}
					const chosen = $scope.accounts.list.find((a) => a.account_id === remembered) || $scope.accounts.list[0];
					$scope.form.accountId = chosen ? chosen.account_id : null;
					if (!$scope.accounts.list.length) $scope.accounts.error = "The Xero organisation has no bank account to take the payment into.";
				})
				.catch(() => ($scope.accounts.error = "Xero's bank accounts couldn't be read."))
				.finally(() => ($scope.accounts.loading = false));
		}

		$scope.setAmount = (v) => ($scope.form.amount = v);
		$scope.methodName = (value) => ((REFERENCE_TYPE.find((m) => m.value === value) || {}).name || value || "").toLowerCase();

		$scope.problem = function () {
			const amount = Number($scope.form.amount);
			if (!(amount > 0)) return "Enter the amount paid.";
			if (amount > $scope.owing() + 0.004) return "That's more than is owing.";
			if ($scope.inXero() && !$scope.form.accountId) return $scope.accounts.error || "Choose the bank account.";
			return null;
		};

		$scope.take = function () {
			if ($scope.problem() || $scope.saving) return;
			$scope.saving = true;
			const amount = Math.round(Number($scope.form.amount) * 100) / 100;
			Store.recordPayment($ctrl.patientId, $ctrl.job, { amount: amount, method: $scope.form.method, accountId: $scope.inXero() ? $scope.form.accountId : null })
				.then(function (saved) {
					try {
						if ($scope.form.accountId) window.localStorage.setItem(accountKey(), $scope.form.accountId);
					} catch (e) {
						// Remembering the account is only a convenience.
					}
					$ctrl.onPaid({ job: saved, amount: amount });
				})
				.catch((resp) => toast.create({ timeout: 6000, message: Store.errorMessage(resp, "The payment couldn't be recorded."), className: "alert-danger", dismissible: true }))
				.finally(() => ($scope.saving = false));
		};
	},
]);
